import { Button, Flex } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { updateRegion } from "../../store/slice/Account/user-profile.slice";
import { useEffect, useState, useRef } from "react";

export const RegionRow: React.FC<any> = (props: any) => {
  const { email, region, isManager } = useSelector(
    (state: RootState) => state.userProfile
  );
  const [text, setText] = useState("");
  const [isAnimating, setIsAnimating] = useState(false);
  const previousText = useRef("");

  const dispatch = useDispatch();

  const initRegion = async () => {
    if (!region) {
      const region = email.endsWith("@zolo.com.au") ? "AU" : "PH";
      setText(region === "AU" ? "Australia" : "Philippines");
      dispatch(updateRegion(region));
    }
  };

  const onMouseEnter = () => {
    if (isManager) {
      previousText.current = text;
      setIsAnimating(true);
      setText(`Switch to ${region === "AU" ? "Philippines" : "Australia"}?`);
    }
  };

  const onMouseLeave = () => {
    if (isManager) {
      previousText.current = text;
      setIsAnimating(true);
      setText(region === "AU" ? "Australia" : "Philippines");
    }
  };

  const switchRegion = async () => {
    if (isManager) {
      setText(region === "AU" ? "Philippines" : "Australia");
      dispatch(updateRegion(region === "AU" ? "PH" : "AU"));

      window.location.reload();
    }
  };

  useEffect(() => {
    initRegion();
  }, [email]);

  useEffect(() => {
    if (region) {
      setText(region === "AU" ? "Australia" : "Philippines");
    }
  }, [region]);

  useEffect(() => {
    if (isAnimating) {
      const timer = setTimeout(() => {
        setIsAnimating(false);
      }, 300); // Match this with the CSS transition duration
      return () => clearTimeout(timer);
    }
  }, [isAnimating]);

  return (
    <LinkStyled
      onClick={switchRegion}
      active={false}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Flex flexDirection="row" gap={4} alignItems={"center"}>
        <Box fontSize="24px">{region === "AU" ? "🇦🇺" : "🇵🇭"}</Box>
        <Box position="relative" overflow="hidden">
          <Box
            className={isAnimating ? "text-animate" : ""}
            position="relative"
            sx={{
              "&.text-animate": {
                animation: "textSweep 0.3s ease-in-out",
              },
              "@keyframes textSweep": {
                "0%": {
                  transform: "translateY(-100%)",
                  opacity: 0,
                },
                "100%": {
                  transform: "translateY(0)",
                  opacity: 1,
                },
              },
            }}
          >
            {text}
          </Box>
        </Box>
      </Flex>
    </LinkStyled>
  );
};

const LinkStyled: React.FC<any> = (props: any) => {
  const { children, onClick, onMouseEnter, onMouseLeave } = props;

  return (
    <Button
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      boxSize="initial"
      justifyContent="flex-start"
      flexDirection="row"
      alignItems="center"
      bg="transparent"
      borderLeftWidth="4px"
      color={"white"}
      borderLeftColor={"transparent"}
      mx={{
        xl: "auto",
      }}
      ps={{
        sm: "10px",
        xl: "16px",
      }}
      _hover={
        {
          // Leave here to override the default hover color
        }
      }
      py="6px"
      borderRadius="0"
      w="100%"
    >
      {children}
    </Button>
  );
};
